export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    baseProfile="tiny"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 33.9 40.1"
    xmlSpace="preserve"
  >
    <polyline
      fill="none"
      stroke="#e60004"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      points="4.1,19.8 14.8,36.1 29.8,4.1"
    />
  </svg>
);
